// noinspection JSUnusedGlobalSymbols

export default class Register
{
	static registered(success)
	{
		if(success) location.href = '/registered/'
	}
}
